module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/band-4ee63bd12e759ee01acb7972d86835d6.webp";